import { render, staticRenderFns } from "./HeaderReport.vue?vue&type=template&id=8a78146e&"
import script from "./HeaderReport.vue?vue&type=script&lang=js&"
export * from "./HeaderReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports